import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { SharedOptions } from '../../types/SharedOptions.js';

const hideSharedOptions: Array<keyof SharedOptions> = ['cachePath', 'features', 'config'];

/** Defines the "report" verb. */
export const init: CommandInitFunction = (program) => {
  const infoCommand = program.addSubCommand({
    name: 'report',
    description: 'Report telemetry data (requires a sub-command).',
    usage: '<command>',
    hideSharedOptions: true,
  });

  infoCommand.addSubCommand({
    name: 'legacy-start',
    description: 'Report the start of a legacy app. This is useful to track cloudpack vs legacy start usage.',
    hideSharedOptions,
    // The run of the "cloudpack report legacy-start" command will be reported to telemetry.
    getExecutor: () =>
      Promise.resolve({
        execute: () => Promise.resolve({ message: 'Legacy start telemetry reported.' }),
      }),
  });
};
